var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.step === 1
        ? _c("OnboardingPage", {
            attrs: {
              selectedMandateType: _vm.selectedMandateType,
              disableMandateType: _vm.disableMandateType,
              loading: _vm.isLoading
            },
            on: { mandateTypeSelected: _vm.handleMandateTypeSelected }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 2
        ? _c("OnboardingCompanyPage", {
            attrs: {
              selectedMandateType: _vm.selectedMandateType,
              company: _vm.company
            },
            on: {
              representativeSelected: _vm.handleLegalRepresentativeSelection
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 3
        ? _c("OnboardingElectronicAddressPage", {
            attrs: { siren: _vm.company.legal_france.siren },
            on: { addressSelected: _vm.handleAddressSelected }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.step === 4
        ? _c("OnboardingLegalRepresentativePage", {
            attrs: {
              legalRepresentative: _vm.legalRepresentative,
              selectedMandateType: _vm.selectedMandateType,
              company: _vm.company
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }